<template>
  <div class="details-box">
    <el-dialog
      :before-close="handleClose"
      :title="details.title"
      :visible.sync="dialogVisible"
      width="75%"
    >
      <el-form
        ref="dataForm"
        :disabled="details.type == 'look'"
        :model="form"
        :rules="rules"
        label-width="180px"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item label="申报人姓名：" prop="stuName">
              {{ form.stuName }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="申报人手机号：" prop="phone">
              {{ form.phone }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="申报人身份证号：" prop="phone">
              {{ form.idcard }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="审核名称：" prop="templateName">
              {{ form.templateName }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="审核批次：" prop="sbpc">
              {{ form.sbpc }}
            </el-form-item>
          </el-col>
        </el-row>
        <div class="table-view">
          <table style="table-layout: fixed">
            <thead>
              <tr>
                <th>资料目录</th>
                <th>评分标准</th>
                <th v-if="form.status >= 3">审核结果</th>
                <th v-if="form.status >= 3">符合/不符合原因</th>
                <th style="width: 260px">上传对应资料</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(group, index) in form.tableData" :key="index">
                <td>
                  {{ group.zbml }}
                </td>
                <td>{{ group.pjbz }}</td>
                <td v-if="form.status >= 3">
                  {{
                    group.result == "1"
                      ? "符合"
                      : group.result == "0"
                        ? "不符合"
                        : ""
                  }}
                </td>
                <td v-if="form.status >= 3">{{ group.remark }}</td>
                <td>
                  <el-form-item
                    :prop="'tableData.' + index + '.fileUrl'"
                    :rules="rules.fileUrl"
                    label-width="0px"
                  >
                    <el-upload
                      v-model="group.fileUrl"
                      :action="$imgHost"
                      :before-upload="beforeUpload.bind(this, group)"
                      :disabled="details.type == 'look'"
                      :file-list="group.fileUrlArr"
                      :limit="1"
                      :on-error="handleError.bind(this, group)"
                      :on-exceed="handleExceed"
                      :on-preview="handlePreview.bind(this, group, 1)"
                      :on-remove="handleRemove.bind(this, group, 1)"
                      :on-success="handleSuccess.bind(this, group, 1)"
                      accept=".png,.jpg,.jpeg,.gif,.pdf,.zip,.7z,.rar"
                      class="upload-demo"
                    >
                      <el-button
                        :disabled="details.type == 'look'"
                        size="small"
                        type="text"
                        >点击上传
                      </el-button>
                    </el-upload>
                  </el-form-item>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <el-row>
          <el-col :span="8">
            <el-form-item label="说明：" prop="templateRemark">
              {{ form.templateRemark }}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button
          v-if="details.type == 'edit' && details.data.status != '-1'"
          :loading="btnLoading"
          @click="handleSubmit(0)"
        >
          保存草稿
        </el-button>
        <el-button
          v-if="details.type == 'edit'"
          :loading="btnLoading"
          type="primary"
          @click="handleSubmit(1)"
        >
          提交审批
        </el-button>
      </span>
      <el-image
        ref="imgViewRef"
        :height="100"
        :preview-src-list="fileUrlList"
        :preview-teleported="true"
        :src="$previewImg + fileUrl"
        :width="100"
        style="display: none"
      >
        <div slot="error" class="image-slot">
          <i class="el-icon-picture-outline" style="font-size: 28px"></i>
        </div>
      </el-image>
    </el-dialog>
    <FileModal
      :details="fileModalDetails"
      @handleClose="userModalClose"
    ></FileModal>
  </div>
</template>
<script>
import FileModal from "./fileModal.vue";
import {
  getXmfzrDeclareRecordDetailsApi,
  batchEditDeclareDetailXmfzrApi,
} from "@/api/home";

export default {
  props: ["details"],
  components: { FileModal },
  data() {
    return {
      srcList: [],
      dialogVisible: false,
      tableData: [],
      fileList: [],
      xh_userInfo: {},
      rules: {
        fileUrl: [{ required: true, message: "请上传资料", trigger: "change" }],
      },
      form: {
        tableData: [],
        stuName: "", // 填报人姓名
        stuId: "",
        phone: "", // 填报人手机号
        templateName: "",
        templateRemark: "",
        sbpc: "",
        idcard: "",
        status: "",
        payment: "",
      },
      fileModalDetails: {
        dialogVisible: false,
        title: "查看附件",
        data: {},
      },
      fileUrl: "",
      fileUrlList: [],
      btnLoading: false,
      multiParams: {
        detailId: "",
      },
    };
  },
  watch: {
    details: {
      handler(newValue, oldValue) {
        // 这里不仅可以监听到对象引用的变化，还能监听到对象内部属性的变化
        console.log(newValue, "newValue");
        if (newValue.dialogVisible) {
          this.dialogVisible = newValue.dialogVisible;
          this.form.stuName = newValue.data.stuName;
          this.form.stuId = newValue.data.stuId;
          this.form.phone = newValue.data.phone;
          this.form.templateName = newValue.data.templateName;
          this.form.sbpc = newValue.data.sbpc;
          this.form.idcard = newValue.data.idcard;
          this.form.templateRemark = newValue.data.templateRemark;
          this.form.status = newValue.data.status;
          this.form.payment = newValue.data.payment;
          this.getById();
        } else {
          this.dialogVisible = false;
        }
      },
      deep: true, // 开启深度监听
    },
  },
  mounted() {},
  methods: {
    // 上传的附件查看
    handlePreviewFj(row) {
      this.fileUrl = this.form.cnsUrl;
      let fileUrlList = [];
      fileUrlList.push(this.$previewImg + this.fileUrl);
      this.fileUrlList = fileUrlList;
      this.$refs.imgViewRef.showViewer = true; // 打开预览
    },
    handleClose() {
      this.$emit("handleClose");
    },
    // 保存草稿，提交初审
    handleSubmit(saveType) {
      console.log("tableData", this.form.tableData);
      //支付状态payment为，待支付的 提示“申请已提交，请尽快缴纳费用。”
      if (this.form.payment == "0") {
        this.$message.info("申请已提交，请尽快缴纳费用。");
        return false;
      }
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          let parmaArr = [];
          this.form.tableData.forEach((item, index) => {
            parmaArr.push({
              id: item.id,
              declareId: this.details.data.id,
              fileUrl: item.fileUrl || "",
              fileName: item.fileName || "",
            });
          });
          let params = {
            templateId: this.details.data.templateId,
            declareId: this.details.data.id,
            saveType: saveType,
            declareDetails: parmaArr,
            stuName: this.form.stuName,
            stuId: this.form.stuId,
            phone: this.form.phone,
          };
          batchEditDeclareDetailXmfzrApi(params).then((res) => {
            if (res.code == 200) {
              this.btnLoading = false;
              this.$emit("handleClose");
              if (saveType == 1 && this.form.payment == "0") {
                // 提交审批：1，待缴费状态：1
                this.$message.success("资料已提交成功，请您尽快缴纳审核费用。");
              }
              console.log("batchEditDeclareDetailXmfzrApi", res);
            }
          });
        } else {
          console.log("验证失败");
          return false;
        }
      });
    },
    getById() {
      // 立即申报 查询模版数据
      getXmfzrDeclareRecordDetailsApi({
        declareId: this.details.data.id,
      }).then((res) => {
        if (res.code == 200) {
          if (Array.isArray(res.result) && res.result.length > 0) {
            let dataArr = res.result.map((item) => {
              item.isEdit = false;
              item.fileUrlArr = item.fileUrl
                ? [
                    {
                      name: item.fileName,
                      url: this.$previewImg + item.fileUrl,
                    },
                  ]
                : [];
              if (item.fileUrl) {
                this.srcList.push(this.$previewImg + item.fileUrl);
              }
              return item;
            });
            this.form.tableData = dataArr;
            console.log("this.form.tableData-getById", this.form.tableData);
          }
        }
      });
    },
    // 上传文件之前的钩子
    beforeUpload(row, file) {
      console.log("beforeUpload", row);
      console.log("beforeUpload", file);
      const { uid, name, size } = file;
      this.multiParams.detailId = row.id;
      console.log(uid, name, size);
      const fileTypeFlag =
        /^.png|.jpg|.jpeg|.gif|.pdf|.zip|.7z|.rar|.gz|.tar$/.test(
          name.substring(name.lastIndexOf(".")).toLowerCase(),
        );
      if (!fileTypeFlag) {
        this.$message({
          message:
            "文件类型只能是.png|.jpg|.jpeg|.gif|.pdf|.zip|.7z|.rar|.gz|.tar",
          type: "warning",
          duration: "5000",
        });
        row.fileUrlArr = [];
        return false;
      }
      // 文件大小限制
      if (size > 1024 * 1024 * 100) {
        this.$message.warning("文件大小不能超过100Mb");
        return false;
      }
    },
    beforeUploadCnsUrl(file) {
      console.log("beforeUploadCnsUrl", file);
      const { uid, name, size } = file;
      // console.log(uid, name, size);
      //   文件类型限制
      const fileTypeFlag = /^.png|.jpg|.jpeg|.gif|.pdf$/.test(
        name.substring(name.lastIndexOf(".")).toLowerCase(),
      );
      if (!fileTypeFlag) {
        this.$message({
          message: "文件类型只能是.png|.jpg|.jpeg|.gif|.pdf",
          type: "warning",
          duration: "5000",
        });
        // this.cnsUrlList = [];
        return false;
      }
      // 文件大小限制
      if (size > 1024 * 1024 * 100) {
        this.$message.warning("文件大小不能超过100Mb");
        return false;
      }
    },
    // 承诺书附件 删除
    handleRemoveCnsUrl(file) {
      this.form.cnsUrl = "";
      this.form.cnsName = "";
      this.cnsUrlList = [];
    },
    // 承诺书附件 上传成功
    handleSuccessCnsUrl(response, file) {
      console.log("file", file.response);

      if (file.response.code == 200) {
        this.form.cnsUrl = response.result.file.filefullpath;
        this.form.cnsName = file.name;
        console.log("response", response.result.file);
        console.log("file", file);
      } else {
        this.form.cnsUrl = "";
        this.form.cnsName = "";
        this.cnsUrlList = [];
      }
    },
    // 文件列表移除文件时的钩子
    handleRemove(row, file, fileList) {
      row.fileUrl = "";
      console.log("handleRemove", file, fileList);
    },
    // 文件超出个数限制时的钩子
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`,
      );
    },
    // 文件上传成功时的钩子
    handleSuccess(scope, type, response, file) {
      // type:1对应资料,2:补充资料
      console.log("scope---", scope);
      console.log("type", type);
      console.log("response", response);
      console.log("file", file);
      if (response.code == 200) {
        if (type == 1) {
          scope.fileUrl = response.result.file.filefullpath;
          scope.fileName = file.name;
        }
        if (type == 2) {
          scope.complementFile = response.result.file.filefullpath;
          scope.complementFileName = file.name;
        }
        if (type == 3) {
          scope.mutilpartFiles.push(response.result[0]);
          console.log("scope.mutilpartFiles", scope.mutilpartFiles);
        }
      } else {
        this.$message.error(response.message);
        if (type == 1) {
          scope.fileUrlArr = [];
        }
        if (type == 2) {
          scope.complementFileArr = [];
        }
      }
    },
    handleError(scope, err, file, fileList) {},
    handlePreview(row, type) {
      // type:1对应资料,2:补充资料
      this.lookFileClick(row, type);
    },
    handleprogress(event, file) {
      console.log("event", event);
    },
    // 查看从业人员、项目负责人 弹窗关闭
    userModalClose(num) {
      console.log("userModalClose关闭", this.form.tableData);
      this.fileModalDetails.dialogVisible = false;
    },
    lookFileClick(group, type) {
      console.log(group, "typeeeeeeee", type);
      if ((type && type == 2) || (type == 1 && group.sourceType == 4)) {
        // 多文件
        return;
      }
      // type:1对应资料,2:补充资料
      // 查看附件
      let fileName =
        type == 1
          ? group.fileName
          : type == 2
            ? group.complementFileName
            : group.fileName;
      let fileUrl =
        type == 1
          ? group.fileUrl
          : type == 2
            ? group.complementFile
            : group.fileUrl;

      const extension = fileName.split(".").pop().toLowerCase();
      const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp"];
      const pdfExtension = "pdf";
      const zipExtensions = ["zip", "rar", "7z", "gz", "tar"];
      if (imageExtensions.includes(extension)) {
        // img
        this.fileUrl = this.$previewImg + fileUrl;
        let fileUrlList = [];
        fileUrlList.push(this.$previewImg + fileUrl);
        this.fileUrlList = fileUrlList;
        this.$refs.imgViewRef.showViewer = true; // 打开预览
      } else if (extension === pdfExtension) {
        // pdf
        this.fileModalDetails.dialogVisible = true;
        console.log("group", group);
        this.fileModalDetails.data = group;
      } else if (zipExtensions.includes(extension)) {
        // 压缩包
        window.location.href = `${this.$previewImg + fileUrl}`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.details-box {
  .table-view {
    width: 100%;
    overflow: auto;
    height: 440px;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  table {
    width: 1200px; /* 表格宽度 */
    border-collapse: collapse; /* 边框合并为一个单一的边框 */
    margin: 20px 0; /* 上下外边距 */
    overflow-y: auto;
  }

  th,
  td {
    border: 1px solid #ddd; /* 单元格边框 */
    padding: 8px; /* 单元格内边距 */
    text-align: center; /* 文本左对齐 */
    height: 45px;
  }

  th {
    background-color: #f2f2f2; /* 表头背景色 */
    color: #333; /* 表头文字颜色 */
  }

  ///deep/ .el-table .warning-row {
  //  background: oldlace;
  //}
  ///deep/ .el-table .success-row {
  //  background: #f0f9eb;
  //}
  ///deep/ .el-table .success-row1 {
  //  background: #d2f3ff;
  //}
  /deep/ .el-image .image-slot {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100px;
    height: 100px;
    background: #f5f7fa;
    color: #909399;
  }
}
</style>
